import axios from 'axios'
import Cookies from 'js-cookie'

const API_URL = process.env.REACT_APP_BACKEND_URL

export const getUserInfo = async () => {
  try {
    const accessToken = Cookies.get('access_token')
    const uuid = Cookies.get('uuid')
    const response = await axios.get(`${API_URL}/api/users/me?uuid=${uuid}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
      params: {
        populate: {
          role: { fields: ['name'] },
        },
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching invoice data:', error)
    throw error
  }
}
